import * as React from 'react';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
// import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import useFetch from 'use-http';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from 'src/reducers';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import Select, { StylesConfig } from 'react-select';
import Personnel from 'src/models/personnel/Personnel';

interface IPersonnelSearchProps {
    showPersonnelData?: (selected: Personnel) => void;
    setIsCollapsed?: (isCollpased: boolean) => void;
}

interface IOptionType {
    value: string;
    label: string;
  }

const PersonnelSearch = (props: IPersonnelSearchProps) => {
    const { get, response } = useFetch();
    const { register, errors } = useForm();
    const [resultsPlaceholder, setResultsPlaceholder] = useState<string>('Select Personnel'); // Used to inform user about personnel list results
    const [isCollapsed, setIsCollapsed] = useState<boolean>(false); // Used to collapse the Search Personnel Panel to make room for other components
    const [isLoading, setIsLoading] = useState<boolean>(true); // isLoading is true if fetching personnel still
    const [isUserSearching, setIsUserSearching] = useState<boolean>(false); // true if the search text is not empty
    const [personnelList, setPersonnelList] = useState<Array<Personnel>>(undefined); // The whole personnel list
    // const [personnelListNames, setPersonnelListNames] = useState<Array<{ value: string; label: string }>>(undefined); // The whole personnel list
    const [personnelSearchResults, setPersonnelSearchResults] = useState<Array<{ value: string; label: string }>>(undefined); // The personnel filtered by search (Name)

    const dispatch = useDispatch();
    let selectedPersonnel = useSelector((state: IRootState) => state.landman.selectedPersonnel); // Personnel selected by the user

    const customStyles: StylesConfig<IOptionType, false> = {
        control: (provided) => ({
          ...provided,
          minHeight: '30px',    // Set a smaller minHeight
          height: '30px',       // Force a smaller height
          padding: '0px',       // Remove internal padding to make it smaller
        }),
        valueContainer: (provided) => ({
          ...provided,
          padding: '0px 8px',   // Adjust padding to make the height smaller
          height: '30px',       // Force height for the container
        }),
        input: (provided) => ({
          ...provided,
          margin: '0px',        // Ensure no margins are added
          padding: '0px',       // Ensure no padding is added
        }),
        indicatorsContainer: (provided) => ({
          ...provided,
          height: '30px',       // Force the height of the dropdown indicators
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          padding: '0px',       // Remove extra padding from the dropdown arrow
        }),
        clearIndicator: (provided) => ({
          ...provided,
          padding: '0px',       // Remove extra padding from the clear indicator
        }),
      };

    useEffect(() => {
        getPersonnel();
        if (selectedPersonnel) {
            console.log('====> SelectedPersonnel = ', selectedPersonnel.firstName, selectedPersonnel.lastName);
        }
    }, []);

    useEffect(() => {
        if (props.setIsCollapsed) {
            props.setIsCollapsed(isCollapsed);
        }
    }, [isCollapsed]);

    // SelectedPersonnel will change when the user clicks on a user or on initial render, if url contains an id
    useEffect(() => {
        if (selectedPersonnel) {
            console.log('====> SelectedPersonnel = ', selectedPersonnel.firstName, selectedPersonnel.lastName);
        }
    }, [selectedPersonnel]);

    // personnelSearchResults is updated when the user clicks, focuses, or types in the Search Bar
    useEffect(() => {
        console.log('====> Search Results = ', personnelSearchResults);

        if (personnelSearchResults?.length) {
            setIsLoading(false);
        }

        setResultsPlaceholder(`Select Personnel (${personnelSearchResults?.length})`);
    }, [personnelSearchResults]);

    // personnelList should only change once, on initial render (it contains the full list of personnel)
    useEffect(() => {
        if (personnelList?.length) {
            console.log('====> Personnel List = ', personnelList);
            let sorted = sortPersonnelByLastName(personnelList);

            let list = sorted?.map(p => {
                return { 
                    label: (p.lmsNumber ? `(${p.lmsNumber}) ` : '') + (p.prefix ? p.prefix + ' ' : '') + p.firstName + ' ' + p.lastName + (p.suffix ? ' ' + p.suffix : ''), 
                    value: `${p.id}` };
            });
            // setPersonnelListNames(list);
            setPersonnelSearchResults(list);

            if (selectedPersonnel) {
                props?.showPersonnelData(selectedPersonnel);
            }
        }
    }, [personnelList]);

    /**
     * Gets the list of Personnel Users and stores in personnelList
     */
    const getPersonnel = async () => {
        let result = await get(`/v1.0/landmen`);
        if (response.ok && result) {
            setPersonnelList(result.items);
        } else {
            console.log('Unable to get the Personnel Data!!! >:c');
        }
    };

    /**
     * Sets the selected Personnel to the store if the given ID is valid and it's not already the same personnel
     * @param id - The Personnel ID
     */
    const setSelectedPersonnel = (e: { value: string; label: string; }) => {

        if (e.value) {
            const personnel = personnelList?.find(p => p.id === parseInt(e.value, 10));

            if (personnel) {
                personnel?.id !== selectedPersonnel?.id ? dispatch({ type: '[landman] SET_SELECTED_PERSONNEL', payload: personnel }) : window.alert('Selected Personnel already set');
            } else {
                window.alert('Selected Personnel is Undefined');
            }
        } else {
            window.alert('id is Invalid');
        }
    };

    const sortPersonnelByLastName = (list: Array<Personnel>) => {
        let sorted = list.sort((a, b) => {
            if (a.lastName < b.lastName) {
                return -1;
            }
            if (a.lastName > b.lastName) {
                return 1;
            }
            return 0;
        });

        return sorted;
    };

    // const search = () => {
    //     let formValues = getValues();
    //     let searchName = formValues?.searchName;
    //     let searchId = formValues?.searchId;
    //     let fullNames = personnelListNames;
    //     let personnelResults = fullNames;

    //     if (searchName?.length || searchId?.length) {
    //         setIsUserSearching(true);
    //         searchName = searchName?.toLowerCase();

    //         if (searchName?.length) {
    //             console.log(searchName);
    //             personnelResults = personnelResults?.filter(person => person.label.toLowerCase().includes(searchName));
    //         }

    //         if (searchId?.length && !isNaN(searchId)) {
    //             console.log(searchId);
    //             personnelResults = personnelResults?.filter(person => person.value.includes(searchId));
    //         }

    //         // Nothing was filtered
    //         if (personnelResults?.length === fullNames?.length) {
    //             setValue('searchId', '');
    //             setValue('searchName', '');
    //             window.alert(`No Personnel with given parameters: searchName: '${searchName}', searchId: '${searchId}'`);
    //         }
    //     } else {
    //         setIsUserSearching(false);
    //     }
    //     setPersonnelSearchResults(personnelResults);
    // };

    if (isLoading) {
        return (
            <div style={{ textAlign: 'center' }}>
                <h2>Loading Personnel...</h2>
            </div>
        );
    } else if (!isCollapsed) {
        return (
            <Page style={{justifyContent: 'center'}}>
                <Page.Section width={6}>
                    <Panel backgroundColor="#D3D3D3">
                        <Panel>
                            <div className="form-row" style={{ padding: '0', margin: '0' }}>
                                <div style={{ width: '73%'}}>
                                    <Select
                                        className="personnel-search-list"
                                        name="searchResults"
                                        placeholder={resultsPlaceholder}
                                        options={personnelSearchResults}
                                        onChange={(e) => setSelectedPersonnel(e)}
                                        onMenuOpen={() => setIsUserSearching(true)}
                                        onMenuClose={() => setIsUserSearching(false)}
                                        onBlur={() => setIsUserSearching(false)}
                                        register={register}
                                        errors={errors}
                                        menuIsOpen={isUserSearching}
                                        isSearchable={true}
                                        styles={customStyles}
                                    />
                                </div>
                                {/* <RHFInputBox
                                    bodyStyle={{ width: '29%', marginLeft: '3rem' }}
                                    style={{ width: '100%', height: '3.6rem', border: '.5px solid LightGray', borderRadius: '5px' }}
                                    name="searchName"
                                    placeholder="Search Personnel By Name"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => search()}
                                    onFocus={() => getValues('searchId') || getValues('searchName') ? setIsUserSearching(true) : null}
                                    onBlur={() => setIsUserSearching(false)}
                                    register={register}
                                    errors={errors}
                                /> */}
                                {/* <RHFInputBox
                                    bodyStyle={{ width: '29%', marginLeft: '2rem' }}
                                    style={{ width: '100%', height: '3.6rem', border: '.5px solid LightGray', borderRadius: '5px' }}
                                    name="searchId"
                                    placeholder="Search Personnel By ID"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => search()}
                                    onFocus={() => getValues('searchId') || getValues('searchName') ? setIsUserSearching(true) : null}
                                    onBlur={() => setIsUserSearching(false)}
                                    register={register}
                                    errors={errors}
                                /> */}
                                <Button
                                    text="(-) Minimize"
                                    className="blue-hover-button"
                                    style={{ width: '27%', height: '3rem', verticalAlign: 'middle', marginLeft: '3rem', borderRadius: '5px' }}
                                    disabled={isCollapsed}
                                    onClick={() => setIsCollapsed(true)}
                                />
                            </div>
                        </Panel>
                    </Panel>
                </Page.Section>
            </Page>
        );
    } else {
        return (
            <div style={{ textAlign: 'center' }}>
                <Button
                    text="(+) Search Personnel"
                    className="blue-hover-button"
                    style={{ height: '2rem', margin: '0', padding: '.2rem' }}
                    onClick={() => setIsCollapsed(false)}
                />
            </div>
        );
    }
};

export default PersonnelSearch;


// WEBPACK FOOTER //
// ./src/components/personnel/components/PersonnelSearch.tsx